import styled from "styled-components";

export const CommonFooterButton = styled.div`
  min-width: 60px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background-color: #d1d1d1;
  color: #424242;
  cursor: pointer;
`;
